import {useEffect, useState} from "react";
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Home from './views/Home.js';
import Login from './views/Login.js';
import ForgotPassword from './views/ForgotPassword.js';
import ResetPassword from "./views/ResetPassword";
import UserInvitation from "./views/UserInvitiation";
import UserClientInvitation from "./views/UserClientInvitiation";

import {getUser} from "./auth/Auth";

import './App.css';

function App() {
    const [user, setUser] = useState(undefined);

    useEffect(() => {
        getUser().then((data) => {
            setUser(data);
        }).catch(() => {
            setUser(null);
        });
    }, []);

    if (user !== undefined) {
        return (
            <Router>
                <Routes>
                    <Route exact path='/' element={user ? <Home/> : <Navigate to="/login"/>}/>
                    <Route exact path='/favorite-files' element={user ? <Home/> : <Navigate to="/login"/>}/>
                    <Route exact path='/manage-clients' element={user ? <Home/> : <Navigate to="/login"/>}/>
                    <Route exact path='/add-client' element={user ? <Home/> : <Navigate to="/login"/>}/>
                    <Route exact path='/favorite-clients' element={user ? <Home/> : <Navigate to="/login"/>}/>
                    <Route exact path='/manage-admins' element={user ? <Home/> : <Navigate to="/login"/>}/>
                    <Route exact path='/account-settings' element={user ? <Home/> : <Navigate to="/login"/>}/>
                    <Route path='/login' element={<Login/>}/>
                    <Route path='/forgot-password' element={<ForgotPassword/>}/>
                    <Route path='/forgot-password/:secret' element={<ResetPassword/>}/>
                    <Route path='/invite/:secret' element={<UserInvitation/>}/>
                    <Route path='/client-invite/:secret' element={<UserClientInvitation/>}/>
                    <Route path='*' element={<Navigate to="/"/>}/>
                </Routes>
                <ToastContainer
                    position="bottom-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover/>
            </Router>
        );
    } else {
        return null;
    }
}

export default App;
